import React from 'react';
import $ from 'jquery'; 

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import { ReactComponent as CloseIcon } from '../../icons/svg/close.svg';
import { ReactComponent as ArrowLeftIcon } from '../../icons/svg/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/svg/arrow-right.svg';

export default class NewsPanel extends NrgComponent {

  _navigateLeft(event) {
    const listItem = $(this.refs['item-list']).find('li')[0];
    const $items = $(this.refs.items);
    const width = $(listItem).outerWidth(true);
    const currentPos = $items.scrollLeft();
    const newPos = (currentPos - width < 0) ? 0 : currentPos - width;

    $items.animate(
      {
        scrollLeft: newPos
      },
      300
    );
  }

  _navigateRight(event) {
    const listItem = $(this.refs['item-list']).find('li')[0];
    const $items = $(this.refs.items);
    const width = $(listItem).outerWidth(true);
    const currentPos = $items.scrollLeft();

    $items.animate(
      {
        scrollLeft: currentPos + width
      },
      300
    );
  }

  render() {

    return (
      <div className={`NewsPanel row mask`} id="news" ref="container" onClick={(event) => this.props.newsActions.closeViaMask(event)}>
        <div className="inner" ref="inner">
          <div className="col-xs-16">
            <div className="row header">
              <div className="col-xs-16">
                <div className="close" onClick={(event) => this.props.newsActions.closePanel(event)}>
                  <CloseIcon viewBox="0 0 93.7 93.7"></CloseIcon>
                </div>
                <h1>{Content.title}</h1>
              </div>
            </div>
            <div className="row cards">
              <div className="col-xs-16">
                <div className="items" ref="items">
                  <ul ref="item-list">
                    {
                      Content.stories.map((story, index) => (
                        <li key={index}>
                          <div className="content-container">
                            <p>{story.date}</p>
                            <h2><a href={story.link}>{story.headline}</a></h2>
                          </div>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
              <div className="col-xs-8 navigation">
                <div className="arrow left" ref="arrow-left" onClick={(event) => this._navigateLeft(event)}>
                  <ArrowLeftIcon viewBox="0 0 97.3 72.3"></ArrowLeftIcon>
                </div>
              </div>
              <div className="col-xs-8 navigation">
                <div className="arrow right" ref="arrow-right" onClick={(event) => this._navigateRight(event)}>
                  <ArrowRightIcon viewBox="0 0 97.3 72.3"></ArrowRightIcon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

};
